// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-1-2[data-v-fb59aa02] {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  grid-gap: 15px;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
